import React from 'react';
import authStorage from '../storages/mobx/authStorage';

function Avatar({ image, haveCircle }) {
  return (
    <div className="media align-items-center">
      <img
        className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded"
        src={image}
        alt=""
      />
      {haveCircle && (
        <div className="dotted-animation">
          <span className="animate-circle" />
          <span className="main-circle" />
        </div>
      )}
    </div>
  );
}

Avatar.propTypes = {};

export default Avatar;
